import { guideEntries, itemSourceMap } from './entries'
import { rewardTotals, activityEvents } from '../invasions'
import { joinList } from '../../utils/text'
import type { GuideFaq } from '../../types/guide'

const titleOf = (id: string) => guideEntries.find((e) => e.id === id)?.title ?? id
const totalJewels = rewardTotals.reduce((s, r) => s + r.jewels, 0)
const totalItems = rewardTotals.reduce((s, r) => s + r.items, 0)

const jewelFaqs: GuideFaq[] = guideEntries
  .filter((e) => e.categoryId === 'joyas-drops' && e.kind === 'item' && (itemSourceMap[e.id] ?? []).length > 0)
  .map((e) => {
    const sources = itemSourceMap[e.id]
    const parts = sources.map((s) => `${titleOf(s.entryId)} (${s.chance}% por cada monstruo)`)
    return {
      id: `faq-${e.id}`,
      question: `¿Dónde consigo ${e.title}?`,
      answer: `En las invasiones ${joinList(parts)}. Cada monstruo de estas invasiones entrega 1 joya garantizada y el tipo de joya depende de la probabilidad.`,
      aliases: e.aliases,
      related: [{ entryId: e.id, sectionId: 'donde-conseguir' }, ...sources.map((s) => ({ entryId: s.entryId, sectionId: 'recompensas' }))],
    }
  })

export const guideFaqs: GuideFaq[] = [
  {
    id: 'faq-horarios',
    question: '¿Cuándo son las invasiones?',
    answer: 'Presiona la letra H dentro del juego para consultar sus horarios. También avisamos por Discord cuando se aproxima una invasión.',
    aliases: ['Horarios de invasiones', 'A qué hora salen las invasiones'],
    related: [{ entryId: 'horarios-invasiones' }, { entryId: 'invasiones', sectionId: 'horarios' }],
  },
  {
    id: 'faq-total-recompensas',
    question: '¿Cuántas joyas reparten las invasiones por día?',
    answer: `Si se derrotan todos los objetivos, ${totalJewels} joyas y ${totalItems} ítems NO Excellent por día y por subservidor. Con ambos servidores principales activos, ${totalJewels * 2} joyas y ${totalItems * 2} ítems NO Excellent.`,
    related: [{ entryId: 'invasiones', sectionId: 'recompensas' }],
  },
  {
    id: 'faq-excellent',
    question: '¿Puedo conseguir ítems Excellent en las invasiones?',
    answer: 'El jefe White Wizard tiene un 20% de probabilidad de entregar un ítem Excellent adicional. Los ítems de Death King y Red Dragon son NO Excellent.',
    related: [{ entryId: 'white-wizard', sectionId: 'recompensas' }],
  },
  ...jewelFaqs,
  {
    id: 'faq-drop-farmeo',
    question: '¿Se redujo el drop de joyas en el farmeo?',
    answer: 'Sí. El drop de joyas e ítems Excellent en el farmeo habitual se redujo. En tu spot sigues teniendo oportunidades y las cajas conservan su componente de azar.',
    related: [{ entryId: 'drop-farmeo' }],
  },
  {
    id: 'faq-otros-eventos',
    question: '¿Qué otros eventos hay además de las invasiones?',
    answer: `Las invasiones se suman a ${joinList(activityEvents.filter((e) => e !== 'Invasiones'))}.`,
    related: [{ entryId: 'invasiones', sectionId: 'actividad' }],
  },
]
